import { z } from 'zod'

import { addressSchema } from '~/components/smart-accounts/schemas/addressSchema'
import { amountSchema } from '~/components/smart-accounts/schemas/amountSchema'
import { chainIdSchema } from '~/components/smart-accounts/schemas/chainIdSchema'

export const tokenAmountSchema = z.object({
  token: addressSchema,
  amount: amountSchema,
  chainId: chainIdSchema,
})

export type TokenAmountFormValues = z.input<typeof tokenAmountSchema>
